import React from 'react';
import PropTypes from 'prop-types';

import { TabProvider, TabConsumer } from './tabs-context';
import TabItem from './tab-item';
import TabList from './tab-list';

const Tabs = ({ adjacent, children, minor }) => (
  <TabProvider>
    <TabConsumer>
      {({ state, selectTab }) => {
        const { activeTabId, tabs } = state;

        const selectTabWithId = tabId => evt => {
          evt.preventDefault();
          selectTab(tabId);
        };

        return (
          <>
            <TabList adjacent={adjacent}>
              {tabs.map(tab => (
                <TabItem
                  id={tab.id}
                  key={tab.id}
                  minor={minor}
                  title={tab.title}
                  href={`#${tab.id}`}
                  adjacent={adjacent}
                  aria-controls={`panel-${tab.id}`}
                  selected={activeTabId === tab.id}
                  onClick={selectTabWithId(tab.id)}
                />
              ))}
            </TabList>
            {children}
          </>
        );
      }}
    </TabConsumer>
  </TabProvider>
);

Tabs.defaultProps = {
  adjacent: false,
  children: null,
  minor: false,
};

Tabs.propTypes = {
  adjacent: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element),
  minor: PropTypes.bool,
};

export default Tabs;
